import ArticleV1 from './article-v1.vue'
import AudioV1 from './audio-v1.vue'
import AssessmentV1 from './assessment-v1.vue'
import DiscussionV1 from './discussion-v1.vue'
import IntentionV1 from './intention-setter-v1.vue'
import JournalV1 from './journal-v1.vue'
import PollV1 from './poll-v1.vue'
import ProfileV1 from './profile-v1.vue'
import ResourceV1 from './resource-v1.vue'

import BasicContentV1 from './basic-content-v1.vue'
import FullscreenV1 from './fullscreen-v1.vue'
import SelfAssessmentV2 from './self-assessment-v2.vue'
import QuizV1 from './quiz-v1.vue'
import PairedComparisonV1 from './paired-comparison-v1.vue'
import VideoV1 from './video-v1.vue'
import VideoWithInstructionsV1 from './video-with-instructions-v1.vue'

const SlideTypesMixin = {
  components: {
    ArticleV1,
    AudioV1,
    AssessmentV1,
    DiscussionV1,
    IntentionV1,
    JournalV1,
    PollV1,
    ProfileV1,
    ResourceV1,
    BasicContentV1,
    SelfAssessmentV2,
    QuizV1,
    PairedComparisonV1,
    VideoV1,
    VideoWithInstructionsV1
  },

  methods: {
    slideType(activity) {
      switch (activity.type) {
        case 'activity_v1_articles':
          return ArticleV1
        case 'activity_v1_audios':
          return AudioV1
        case 'activity_v1_assessments':
          return AssessmentV1
        case 'activity_v1_discussions':
          return DiscussionV1
        case 'activity_v1_intention_setters':
          return IntentionV1
        case 'activity_v1_journals':
          return JournalV1
        case 'activity_v1_polls':
          return PollV1
        case 'activity_v1_profiles':
          return ProfileV1
        case 'activity_v1_resources':
          return ResourceV1
        case 'activity_v1_basic_contents':
          return BasicContentV1
        case 'activity_v1_fullscreens':
          return FullscreenV1
        case 'activity_v2_self_assessments':
          return SelfAssessmentV2
        case 'activity_v1_quizzes':
          return QuizV1
        case 'activity_v1_self_assessments':
          return QuizV1
        case 'activity_v1_paired_comparisons':
          return PairedComparisonV1
        case 'activity_v1_videos':
          return VideoV1
        case 'activity_v1_video_with_instructions':
          return VideoWithInstructionsV1
        default:
          return null
      }
    }
  }
}

export default SlideTypesMixin
